import { compose } from 'redux'

// higher-order components
import withRedux from './withRedux'
import withQuery from './withQuery'
import withEffects from 'components/virtual/shared/ScheduleRefresher/withEffects'
import withQueryResults from 'components/shared/withQueryResults'

// presentational component
import UI from './UI'

export default compose(
  withRedux, // for setting error state
  withQueryResults,
  withQuery, // for fetching rooms data
  withEffects // for 10-minute refetch timer
)(UI)
